<span nz-icon>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="6" width="16" height="2" rx="1" fill="#333333" />
    <rect x="4" y="11" width="12" height="2" rx="1" fill="#333333" />
    <rect x="4" y="16" width="8" height="2" rx="1" fill="#333333" />
  </svg>
</span>
